import { createBrowserHistory } from 'history';
import { BrowserRouter } from 'react-router-dom';

export const history = createBrowserHistory();

export class JarvisBrowserRouter extends BrowserRouter {
    history = history;
}
